import React from 'react';
import {Modal} from "./modal.jsx";
import Button from "../button/button.jsx";

const API_KEEPER = import.meta.env.VITE_API_KEEPER;
const imgExtensions = ['jpg', 'jpeg', 'png', 'image/jpg', 'image/jpeg', 'image/png', 'gif', 'svg', 'image/webp'];

const ModalAttaches = ({
    open,
    setOpen,
    file,
    removeFile,
    attachUrl = API_KEEPER + "/ged/attach/",
    pdfUrl = API_KEEPER + "/ged/attach/print/pdf/",
    title = "Anexo"
}) => {
    const getFileExtension = (file) => String(file?.type || file?.extension || "").toLowerCase();
    const ext = getFileExtension(file);
    const isImage = imgExtensions.includes(ext);

    const downloadFile = (file) => {
        const urlFile = (file.attachId && !file.url) ? attachUrl + file.attachId : file.url

        let link = document.createElement("a");
        link.href = urlFile;
        link.target = '_blank';
        link.download = "attach"

        document.body.appendChild(link);

        link.click();

        document.body.removeChild(link);
    }

    const modalContent = () => {
        if (!file) return;

        if (!imgExtensions.includes(ext) && ext !== "application/pdf" && ext !== "pdf") {
            return <h3 className="text-center text-[18px] font-bold">Arquivo {file.name}</h3>;
        } else if (ext === "application/pdf" || ext === "pdf") {
            const url = (file.attachId && !file.url) ? pdfUrl + file.attachId : file.url
            return (
                <h3 className="text-center text-[18px] font-bold underline">
                    <a href={url} target="_blank">Clique para visualizar o arquivo PDF</a>
                </h3>
            )
        } else {
            const url = (file.attachId && !file.url) ? attachUrl + file.attachId : file.url
            return <img src={url} alt={file.name} className={"block h-[calc(100vh-190px)] max-w-full object-contain"}/>
        }
    }

    return (
        <Modal open={open} setOpen={setOpen} title={title} backdrop="static" keyboard={false} className={isImage ? "w-fit max-w-[calc(100vw-2rem)]" : undefined}>
            <Modal.Body className="pb-2 flex justify-center h-fit!">
                {modalContent()}
            </Modal.Body>
            <Modal.Footer>
                {
                    removeFile &&
                    <Button target="danger" onClick={() => removeFile(file)}>
                        Remover
                    </Button>
                }
                <Button target="secondary" onClick={() => downloadFile(file)}>
                    Download
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalAttaches;